<app-table
  [lazy]="true"
  [cols]="columns"
  tableTitle="Cancelada com Billing Pendente"
  [addButton]="false"
  [exportPdf]="false"
  [exportExcel]="false"
  [refreshButton]="false"
  [service]="itOpsService"
  pageFunctionName="getCanceledWithPendinBillingTable"
  emptyMessage="Sem mais assinantes canceladas com billing pendente no momento."
  selectionActionLabel="Corrigir"
  selectionActionTooltip="Marcar como resolvido"
  selectionActionIcon="pi pi-check"
  (emitSelection)="openActionModal($event)"
  modelName="Registros"
  [defaultRows]="15"
  [dropdownFilters]="dropdownFilters"
  [multiSelectFilter]="true"
  *ngIf="ready && dropdownFilters"
></app-table>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
